import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export function LoadingSpinner() {
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setIsLoading(true)
    const timer = setTimeout(() => setIsLoading(false), 500)
    return () => clearTimeout(timer)
  }, [location])

  if (!isLoading) return null

  return (
    <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="relative">
        {/* Rotating ring */}
        <div className="absolute inset-0 animate-spin">
          <svg className="w-24 h-24" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="url(#gradient)"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="70 200"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#9333ea" />
                <stop offset="100%" stopColor="#3b82f6" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        {/* CloudNestle logo with pulse */}
        <div className="relative w-24 h-24 flex items-center justify-center animate-pulse">
          <svg className="w-12 h-12" viewBox="0 0 100 100" fill="none">
            {/* Cloud icon */}
            <path
              d="M80 60c6.627 0 12-5.373 12-12 0-6.627-5.373-12-12-12-1.163 0-2.29.166-3.356.478C74.919 28.516 67.923 22 59.5 22c-6.904 0-12.865 4.262-15.321 10.295C43.456 32.105 42.74 32 42 32c-8.837 0-16 7.163-16 16 0 .337.01.671.03 1.003C20.22 50.48 16 55.454 16 61.333 16 68.806 22.194 75 29.667 75H80z"
              fill="url(#logoGradient)"
            />
            <defs>
              <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#9333ea" />
                <stop offset="100%" stopColor="#3b82f6" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        {/* Loading text */}
        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
          <p className="text-sm font-medium text-gray-600 animate-pulse">Loading...</p>
        </div>
      </div>
    </div>
  )
}
